import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FrameTooBigExceptionClass;
function FrameTooBigException() {
  if (FrameTooBigExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(frameSize, cause) {
        return new.target.v5c(frameSize, cause);
      }
      static v5c(frameSize, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.zd(cause);
        captureStack($this, $this.u5c_1);
        $this.t5c_1 = frameSize;
        delete $this.message;
        return $this;
      }
      r() {
        var sizeSuffix = this.t5c_1 >= 0n ? ': ' + this.t5c_1.toString() : '';
        return 'Frame is too big' + sizeSuffix;
      }
      l13() {
        return FrameTooBigException().v5c(this.t5c_1, this);
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'FrameTooBigException', VOID, VOID, [CopyableThrowable()]);
    FrameTooBigExceptionClass = $;
  }
  return FrameTooBigExceptionClass;
}
//region block: exports
export {
  FrameTooBigException as FrameTooBigException1rgdafsgu31sm,
};
//endregion

//# sourceMappingURL=FrameTooBigException.mjs.map
